<template>
  <div class="allallsize">
    <div class="allsize">
      <div class="first">
        <div class="topone">
          <div class="onetext">海洋观测系统动态监控平台</div>
        </div>
        <div class="righttop">
          <div class="topicon">
            <img class="icon"
                 src="static/time.png" />
          </div>
          <div class="toptime">时间</div>
          <div class="block">

            <el-date-picker v-model="value1"
                            value-format="yyyy-MM-dd"
                            type="datetimerange"
                            :unlink-panels="true"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="selectTime">
            </el-date-picker>
          </div>

        </div>
      </div>
      <div class="second">
        <div class="second6kuang">
          <div class="toptwo">
            <div class="twosquare">
              <div class="words">经度</div>
              <div class="number">{{ jd }}</div>
            </div>

            <div class="twosquare2">
              <div class="words">纬度</div>
              <div class="number">{{ wd }}</div>
            </div>

            <div class="twosquare2">
              <div class="words">波向(°)</div>
              <div class="number">{{ toFixedFn(bx) }}</div>
            </div>

            <div class="twosquare2">
              <div class="words">温度(°C)</div>
              <div class="number">{{ toFixedFn(wend) }}</div>
            </div>

          </div>
          <div class="toptwoa">
            <div class="twosquare">
              <div class="words">波高(m)</div>
              <div class="number">{{ toFixedFn(bg) }}</div>
            </div>

            <div class="twosquare2">
              <div class="wordsbzq">波周期(s)</div>
              <div class="number">{{ toFixedFn(bzq) }}</div>
            </div>

            <div class="twosquare2">
              <div class="words">气压(hPa)</div>
              <div class="number">{{ toFixedFn(qy) }}</div>
            </div>

            <div class="twosquare2">
              <div class="words">电压(v)</div>
              <div class="number">{{ toFixedFn(dy) }}</div>
            </div>
          </div>

        </div>
        <div class="leftbottom">
          <div class="bottomword">风向</div>
          <div class="leftbtm2">
            <div class="bottomimg">
              <div class="circleonea">
                <img class="circle2"
                     src="../../public/static/fximg.png" />
              </div>
              <div class="bgcolor"></div>

              <div class="bgwhite"
                   :style="{transform:'rotate(' + fx + 'deg)'}">

                <div class="jiantou"></div>
              </div>
              <div class="word98">{{fxleft}}°</div>
            </div>
            <div class="btmrhtall">
              <div class="btmrhtone">
                <div class="btmwordone">风向(°)</div>
                <div class="btmwordtwo">{{toFixedFn(fx)}}</div>
              </div>
              <div class="btmrhttwo">
                <div class="btmwordone">风速(m)</div>
                <div class="btmwordtwo">{{toFixedFn(fs)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="third">

        <div id="middleChart"
             v-if="showchart"></div>
      </div>
      <div class="fourth">

        <div class="table34">
          <div class="table3">
            <div class="title3">
              <div class="title3all">
                <div class="title24hleft">24h最大</div>
                <div class="title24hleft2">风速</div>
              </div>
              <div class="title3all">
                <div class="title3word">最大风速(m)</div>
                <div class="title24h">{{toFixedFn(zdfs)}}</div>
              </div>
              <div class="title3all">
                <div class="title3word">最大风向(°)</div>
                <div class="title24h">{{toFixedFn(zdfx)}}</div>
              </div>
              <div class="title3all">
                <div class="title3word1">时间</div>
                <div class="title24h1">{{title3time}}</div>
              </div>
            </div>
            <div>
              <table border="0"
                     class="table30">
                <tr class="table31">
                  <td class="table301">最新</td>
                  <td class="table301">时间</td>
                  <td class="table301">风速(m)</td>
                  <td class="table301">风向(°)</td>
                </tr>
                <tr v-for="(max1,index) in listrev"
                    :key="max1.id"
                    :value="max1">
                  <td class="table311">{{index+1}}</td>
                  <td class="table321">{{max1['时间']}}</td>
                  <td class="table321">{{toFixedFn(max1['风速'])}}</td>
                  <td class="table321">{{toFixedFn(max1['风向'])}}</td>
                </tr>
              </table>
            </div>
          </div>

          <div class="table4">
            <div class="title4">
              <div class="title4all">
                <div class="title24hleft">24h最大</div>
                <div class="title24hleft2">波高</div>
              </div>
              <div class="title4all">
                <div class="title3word">最大波高(m)</div>
                <div class="title24h">{{toFixedFn(zdbg)}}</div>
              </div>
              <div class="title4all">
                <div class="title3word">波周期(s)</div>
                <div class="title24h">{{toFixedFn(zdbzq)}}</div>
              </div>
              <div class="title4all">
                <div class="title3word">波向(°)</div>
                <div class="title24h">{{toFixedFn(zdbx)}}</div>
              </div>
              <div class="title4all">
                <div class="title3word1">时间</div>
                <div class="title24h1">{{title3time}}</div>
              </div>
            </div>
            <div>
              <table border="0"
                     class="table40">
                <tr class="table41">
                  <td class="table301">最新</td>
                  <td class="table301">时间</td>
                  <td class="table301">波高(m)</td>
                  <td class="table301">波周期(s)</td>
                  <td class="table301">波向(°)</td>
                </tr>
                <tr v-for="(max2,index) in listrev"
                    :key="max2.index">
                  <td class="table311">{{index+1}}</td>
                  <td class="table322">{{max2['时间']}}</td>
                  <td class="table3212">{{toFixedFn(max2['波高'])}}</td>
                  <td class="table322">{{toFixedFn(max2['波周期'])}}</td>
                  <td class="table3212">{{toFixedFn(max2['波向'])}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="table67">
          <div class="table6">
            <div class="shijian">时间</div>
            <div class="table6time">
              <div class="time1">{{newtimert}}</div>
            </div>
          </div>

          <div class="table7">
            <div class="boxiang">波向</div>
            <div class="table7btm">
              <div class="btmcircle1">
                <div class="btmcircle2"
                     :style="{transform:'rotate(' + bxright + 'deg)'}">
                  <div class="jiantou2"></div>
                </div>
                <div class="wordbx">{{bxright}}°</div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="bottom-banner">
      <img class="img"
           src="static/ad.png">
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import '../assets/rem2'
import { setToken, setUser } from '../utils/auth'
// 导入接口：
import { bigfloater, login } from '../service/getData'
const echarts = require('echarts')
let intervalID
export default {
  data() {
    return {
      value1: [
        //格式化选择的开始时间，当前时间的一年前
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
        //选择的当前时间
        moment().format('YYYY-MM-DD')
      ],
      showchart: true,
      listrev: null,
      jd: null,
      wd: null,
      bg: null,
      bzq: null,
      bx: null,
      bxright: null,
      wend: null,
      qy: null,
      dy: null,
      fx: null,
      fxleft: null,
      fs: null,
      fxnote: null,
      title3time: null,
      equipid: 14,
      number: 10,
      listJd: null,
      zdfs: null,
      zdfx: null,
      zdbg: null,
      zdbzq: null,
      zdbx: null,
      newtimert: null,
      toptimebegin: null,
      bdt:
        null ||
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
      edt: null || moment().format('YYYY-MM-DD'),
      isActive: false
    }
  },
  methods: {
    // 选择完时间点击确定后调用
    // time数组用来接收存放用户选择的时间
    // 如果time不为空，即用户选择了时间
    // 那么参数改变并传递给后台
    selectTime(time) {
      if (time != null && time.length != 0) {
        this.bdt = time[0]
        this.edt = time[1]
      }
      this.draw()
    },
    // 格式化两位
    toFixedFn(v) {
      return v ? Number(v).toFixed(2) : v
    },

    async draw() {
      let middleChart = echarts.init(document.getElementById('middleChart'))

      let res3 = await bigfloater(this.equipid, this.number, this.bdt, this.edt)
      let data = res3.data && res3.data.AppendData.eqdata
      // 将获取到的data(字符串)的数据转换成对象(let XX = JSON.parse(YY))
      let listJd = JSON.parse(data)

      let listjdDtl = listJd[0]

      let obj = []

      for (let i in listjdDtl) {
        obj.push(listjdDtl[i])
      }

      this.jd = obj[2]
      this.wd = obj[4]
      this.bg = obj[8]
      this.bzq = obj[11]
      this.bx = obj[12]

      this.wend = obj[10]
      this.qy = obj[7]
      this.dy = obj[14]

      this.fxnote = obj[15]

      let fxcut = obj[15]
      this.fxleft = Number(fxcut).toFixed(0)

      this.fx = obj[15]
      this.fs = obj[6]

      this.title3time = obj[1]
      let data2 = res3.data.AppendData.eqmax
      let listWind = JSON.parse(data2)
      let listwindDtl = listWind[0]
      let obj1 = []
      for (let i in listwindDtl) {
        obj1.push(listwindDtl[i])
      }
      // 根据下标找到值后渲染在页面中
      this.zdfs = obj1[0]
      this.zdfx = obj1[7]
      this.zdbg = obj1[2]
      this.zdbzq = obj1[4]
      this.zdbx = obj1[5]
      let bxcut = obj1[5]
      this.bxright = Number(bxcut).toFixed(0)

      let data3 = res3.data.AppendData.eqhistory

      let data4 = res3.data.AppendData.eqparam

      let listchart = JSON.parse(data3)
      this.listchart = listchart
      this.listrev = this.listchart && this.listchart.reverse().slice(0, 5)

      var m = {}
      data4.map(item => {
        listchart &&
          listchart.map(data4 => {
            if (!(m[item.paramnm] instanceof Array)) {
              m[item.paramnm] = []
            }
            m[item.paramnm].push([data4['时间'], data4[item.paramnm]])
          })
      })
      let mparamnm = []
      for (let a in m) {
        mparamnm.push(m[a])
      }

      let betime = []
      for (let i in listchart) {
        betime.push(listchart[i])
      }

      let benewtime = betime
      let righttime = []
      for (let c in benewtime[0]) {
        righttime.push(benewtime[0][c])
      }
      this.newtimert = righttime[1]

      let topbgtime = benewtime[benewtime.length - 1]
      let topendtime = []
      for (let d in topbgtime) {
        topendtime.push(topbgtime[d])
      }
      this.toptimebegin = topendtime[1]

      middleChart.setOption({
        legend: {
          left: '5%',
          textStyle: {
            color: 'rgba(169,169,169,1)',
            fontWeight: 500,
            fontFamily: 'NotoSansHans-Medium',
            fontSize: 10,
            lineHeight: 11
          },

          data: [
            {
              icon: 'circle',
              name: '风速'
              //name:listlegend[0].paramnm,
            },
            {
              icon: 'circle',
              name: '气压'
              //name:listlegend[1].paramnm,
            },
            {
              icon: 'circle',
              name: '波高'
              //name:listlegend[2].paramnm,
            },
            {
              icon: 'circle',
              name: '温度'
              //name:listlegend[3].paramnm,
            },
            {
              icon: 'circle',
              name: '波周期'
              //name:listlegend[4].paramnm,
            },
            {
              icon: 'circle',
              name: '波向'
              //name:listlegend[5].paramnm,
            },
            {
              icon: 'circle',
              name: '电压值'
              //name:listlegend[6].paramnm,
            },
            {
              icon: 'circle',
              name: '风向'
              //name:listlegend[7].paramnm,
            }
          ]
        },
        grid: {
          left: '5%',
          top: '12%',
          right: '2%'
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true
          },

          boundaryGap: false,
          nameTextStyle: {
            fontSize: 7,
            fontFamily: 'NotoSansHans-Medium',
            fontWeight: 500,
            color: 'rgba(150,150,150,1)'
          },
          splitNumber: 14
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            // show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          // 风速
          {
            showSymbol: false,
            name: '风速',
            //name:listlegend[0].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            //data: [],
            data: mparamnm[0],
            // data: [150,283,180,100,167,170,200,70,285,240,90,70,75,10],
            lineStyle: {
              color: '#5C97FD',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#5C97FD'
            }
          },
          // 气压
          {
            showSymbol: false,
            name: '气压',
            //name:listlegend[1].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[1],
            //data: [150,200,180,285,240,160,70,75,100,100,70,170,200,270],
            lineStyle: {
              color: '#36CFC9',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#36CFC9'
            }
          },
          // 波高
          {
            showSymbol: false,
            name: '波高',
            //name:listlegend[2].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[2],
            // data: [150,200,200,270,285,240,160,70,180,100,70,170,75,100],
            lineStyle: {
              color: '#A26DEB',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#A26DEB'
            }
          },
          // 温度
          {
            showSymbol: false,
            name: '温度',
            //name:listlegend[3].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[3],
            //data: [170,200,270,285,150,200,180,100,70,240,160,70,75,100],
            lineStyle: {
              color: '#F759AB',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#F759AB'
            }
          },
          //波周期
          {
            showSymbol: false,
            name: '波周期',
            //name:listlegend[4].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[4],
            //data: [150,200,180,100,70,170,200,270,285,240,160,70,75,100],
            lineStyle: {
              color: '#FFF566',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#FFF566'
            }
          },
          // 波向
          {
            showSymbol: false,
            name: '波向',
            //name:listlegend[5].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[5],
            //data: [150,200,200,270,285,240,160,70,75,100,180,100,70,170,],
            lineStyle: {
              color: '#FFC53D',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#FFC53D'
            }
          },
          //电压值
          {
            showSymbol: false,
            name: '电压值',
            //name:listlegend[6].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[6],
            //data: [150,200,180,,240,160,70,75,100,100,70,170,200,270,285],
            lineStyle: {
              color: '#FF7A45',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#FF7A45'
            }
          },
          // 风向
          {
            showSymbol: false,
            name: '风向',
            //name:listlegend[7].paramnm,
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[7],
            //data: [150,200,170,200,270,285,240,160,70,75,180,100,70,100],
            lineStyle: {
              color: '#FF4D4F',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#FF4D4F'
            }
          }
        ]
      })
    },
    // 进入页面自动登录
    async submit() {
      let result = await login('test', '123456')
      let data = result.data
      if (data.ResultType == 0) {
        setToken(data.AppendData)
        setUser(this.unm)
      } else {
        this.$message({
          message: data.Message,
          type: 'error'
        })
      }
    }
  },

  async mounted() {
    await this.submit()
    await this.draw()
    intervalID = setInterval(() => {
      this.draw()
    }, 60000)
  },
  destroyed() {
    clearInterval(intervalID)
  }
}
</script>

<style lang="scss" scoped>
.allsize {
  height: 52.3vh;
  overflow: hidden;
}
.bottom-banner {
  height: 47.7vh;
  overflow: hidden;
}
.first {
  display: flex;
  margin-top: 0.28rem;
  .topone {
    width: 3.69rem;
    height: 0.62rem;
    background: rgba(92, 151, 253, 1);
    border-radius: 0.35rem 0rem 0.35rem 0rem;
    margin-left: 0.41rem;
    margin-top: 0.17rem;
    .onetext {
      width: 3.08rem;
      height: 0.36rem;
      font-size: 0.25rem;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 0.36rem;
      text-shadow: 0rem 0.01rem 0.06rem rgba(0, 0, 0, 0.3);
      margin-left: 0.36rem;
      padding-top: 0.13rem;
    }
  }
  .righttop {
    margin-left: 0.59rem;
    //width: 6.3rem;
    display: flex;
    .topicon {
      width: 0.3rem;
      height: 0.3rem;
      .icon {
        width: 0.36rem;
        height: 0.36rem;
        margin-top: 0.3rem;
      }
    }
    .toptime {
      height: 0.13rem;
      font-size: 0.13rem;
      margin-left: 0.2rem;
      margin-top: 0.41rem;
      font-family: NotoSansHans-Regular;
      font-weight: 400;
      color: rgba(41, 41, 41, 1);
      line-height: 0.19rem;
    }
    .block {
      margin-left: 0.2rem;
      margin-top: 0.3rem;
    }
  }
}
.second {
  display: flex;
  margin-top: 0.23rem;
  .second6kuang {
    margin-left: 0.6rem;
  }
  .leftbottom {
    margin-top: 0.15rem;
    margin-left: 0.3rem;
    .bottomword {
      width: 0.35rem;
      height: 0.17rem;
      font-size: 0.17rem;
      font-family: NotoSansHans-Regular;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 0.26rem;
      margin-left: 0.35rem;
    }
    .leftbtm2 {
      display: flex;
      .bottomimg {
        width: 1.84rem;
        height: 1.84rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0rem 0.01rem 0.14rem 0rem rgba(203, 223, 254, 1);
        border: 0.03rem solid #cbdffe;
        border-radius: 1rem;
        z-index: 1;
        margin-left: 0.49rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .circle2 {
          position: relative;

          width: 1.3rem;
          height: 1.3rem;
        }
        .bgcolor {
          border-radius: 1rem;
          border: 0.015rem solid rgba(255, 255, 255, 1);
          position: absolute;
          width: 1rem;
          height: 1rem;
          background: linear-gradient(to right, #467fff, #64ffe4);

          z-index: 2;
        }
        .bgwhite {
          border-radius: 1rem;
          border: 0.015rem solid rgba(255, 255, 255, 1);
          position: absolute;
          width: 0.83rem;
          height: 0.83rem;
          background: rgba(255, 255, 255, 1);

          z-index: 3;
          .jiantou {
            width: 0rem;
            height: 0rem;
            border-left: 0.5rem solid transparent;
            border-bottom: 1rem solid #457fff;
            border-right: 0.5rem solid transparent;
            border-width: 0rem 0.04rem 0.1rem 0.04rem;
            margin-left: 0.37rem;
            margin-top: 0.025rem;
          }
        }
        .word98 {
          width: 0.45rem;
          height: 0.4rem;
          position: absolute;
          z-index: 4;
          font-size: 0.23rem;
          font-family: NotoSansHans-Bold;
          font-weight: 550;
          color: rgba(0, 0, 0, 0.85);
          line-height: 0.39rem;

          text-align: center;
        }
      }
      .btmrhtall {
        margin-left: 0.1rem;
        .btmrhtone {
          height: 0.78rem;
          width: 1.16rem;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0rem 0rem 0.15rem 0rem rgba(203, 223, 254, 1);
          border-radius: 0.15rem;
          border: 0.015rem solid #cbdffe;
          //margin-top: 45px;
          margin-left: 0.25rem;
        }
        .btmrhttwo {
          height: 0.78rem;
          width: 1.16rem;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0rem 0rem 0.1rem 0rem rgba(203, 223, 254, 1);
          border-radius: 0.15rem;
          border: 0.015rem solid #cbdffe;
          margin-top: 0.15rem;
          margin-left: 0.25rem;
        }
      }
    }
  }

  .toptwo {
    display: flex;
    margin-left: 0.54rem;
    margin-top: 0.24rem;
  }
  .toptwoa {
    display: flex;
    margin-left: 0.54rem;
    margin-top: 0.15rem;
    .wordsbzq {
      width: 0.78rem;
      height: 0.16rem;
      font-size: 0.15rem;
      font-family: NotoSansHans-Regular;
      font-weight: 400;
      color: rgba(92, 92, 92, 1);
      margin-left: 0.42rem;
      margin-top: 0.13rem;
      line-height: 0.24rem;
    }
  }
  .twosquare {
    height: 0.78rem;
    width: 1.39rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
    border-radius: 0.2rem;
    border: 0.03rem solid #cbdffe;
  }
  .twosquare2 {
    height: 0.78rem;
    width: 1.39rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
    border-radius: 0.2rem;
    border: 0.03rem solid #cbdffe;
    margin-left: 0.36rem;
  }
  .words {
    width: 0.78rem;
    height: 0.16rem;
    font-size: 0.15rem;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    color: rgba(92, 92, 92, 1);
    margin-left: 0.35rem;
    margin-top: 0.13rem;
    line-height: 0.24rem;
    text-align: center;
  }
  .number {
    font-size: 0.2rem;
    font-family: NotoSansHans-Regular;
    font-weight: 550;
    color: rgba(38, 38, 38, 1);
    text-align: center;
    line-height: 0.35rem;
  }
  .btmwordone {
    width: 0.78rem;
    height: 0.16rem;
    font-size: 0.15rem;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    text-align: center;
    color: rgba(92, 92, 92, 1);
    line-height: 0.24rem;
    margin-left: 0.22rem;
    margin-top: 0.13rem;
  }
  .btmwordtwo {
    height: 0.23rem;
    font-size: 0.2rem;
    font-family: NotoSansHans-Medium;
    font-weight: 550;
    color: rgba(38, 38, 38, 1);
    line-height: 0.35rem;
    text-align: center;
  }
}
.third {
  margin-left: 0.5rem;
  margin-top: 0.25rem;
  #middleChart {
    width: 95%;
    height: 3.25rem;
  }
}
.fourth {
  display: flex;
  margin-top: 0.18rem;
  .table34 {
    display: flex;
    margin-left: 0.55rem;
    .table3 {
      width: 4rem;
      .title3 {
        display: flex;
        border: 0.01rem solid #dcdcdc;
        height: 0.61rem;
      }
      .table30 {
        border: 0.01rem solid #dcdcdc;
        height: 2.08rem;

        margin-top: 0.1rem;
        border-collapse: collapse;
      }
      .table31 {
        background: rgba(212, 232, 255, 0.8);
      }
    }
    .table4 {
      margin-left: 0.45rem;
      width: 5rem;
      .title4 {
        display: flex;
        border: 0.01rem solid #dcdcdc;
        height: 0.61rem;
        margin-left: 0.18rem;
        .title4all {
          width: 20%;
          height: 100%;
        }
      }
      .table41 {
        background: rgba(212, 232, 255, 0.8);
      }
      .table40 {
        border: 0.01rem solid #dcdcdc;
        height: 2.08rem;

        margin-top: 0.1rem;
        margin-left: 0.18rem;
        border-collapse: collapse;
      }
      .table32 {
        width: 25%;
        border-right: 0.01rem solid #dcdcdc;
        border-bottom: 0.01rem solid #dcdcdc;
        text-align: center;
        font-size: 0.1rem;
        font-weight: 500;
        color: rgba(57, 68, 70, 1);
      }
      .table3212 {
        width: 20%;
        border-right: 0.01rem solid #dcdcdc;
        border-bottom: 0.01rem solid #dcdcdc;
        text-align: center;
        font-size: 0.07rem;
        color: rgba(135, 135, 135, 1);
        padding-top: 0.075rem;
        padding-bottom: 0.075rem;
      }
    }
  }
  .table67 {
    margin-left: 0.5rem;
    .table6 {
      margin-top: 0.2rem;
      .shijian {
        text-align: center;
        font-size: 0.17rem;
        font-family: NotoSansHans-Medium;
        font-weight: 550;
        color: rgba(0, 0, 0, 1);
        line-height: 0.27rem;
        margin-left: 0.2rem;
      }
      .table6time {
        height: 0.78rem;
        width: 1.16rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
        border-radius: 0.2rem;
        border: 0.03rem solid #cbdffe;
        margin-top: 0.1rem;
        margin-left: 0.2rem;
        .time1 {
          text-align: center;
          font-size: 0.17rem;
          font-family: NotoSansHans-Regular;
          font-weight: 550;
          color: #394446;
          line-height: 0.2rem;
          margin-top: 0.17rem;
        }
      }
    }
    .table7 {
      margin-top: 0.15rem;
      .boxiang {
        text-align: center;
        font-size: 0.17rem;
        font-family: NotoSansHans-Medium;
        font-weight: 550;
        color: rgba(0, 0, 0, 1);
        line-height: 0.27rem;
        margin-left: 0.2rem;
      }
      .table7btm {
        width: 1.05rem;
        height: 1.05rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0rem 0.02rem 0.1rem 0rem rgba(203, 223, 254, 1);
        border: 0.02rem solid #cbdffe;
        border-radius: 1rem;
        margin-top: 0.09rem;
        margin-left: 0.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        .btmcircle1 {
          width: 0.8rem;
          height: 0.8rem;
          background: linear-gradient(to right, #467fff, #64ffe4);
          border: 0.02rem solid rgba(255, 255, 255, 1);
          border-radius: 1rem;

          position: relative;
          .btmcircle2 {
            width: 0.65rem;
            height: 0.65rem;
            background: rgba(255, 255, 255, 1);
            border-radius: 1rem;
            margin-left: 0.078rem;
            margin-top: 0.06rem;
            position: absolute;
            z-index: 1;
            .jiantou2 {
              width: 0rem;
              height: 0rem;
              border-left: 0.5rem solid transparent;
              border-bottom: 1rem solid #457fff;
              border-right: 0.5rem solid transparent;
              border-width: 0rem 0.03rem 0.1rem 0.03rem;
              margin-left: 0.3rem;
              // margin-top: 5px;
            }
          }
          .wordbx {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            z-index: 4;
            font-size: 0.15rem;
            font-family: NotoSansHans-Bold;
            font-weight: 550;
            color: rgba(0, 0, 0, 0.85);
            line-height: 0.54rem;
            margin-left: 0.27rem;
            margin-top: 0.1rem;
            text-align: center;
          }
        }
      }
    }
  }
  .title3all {
    width: 25%;
    height: 100%;
  }
  .title3word {
    font-size: 0.07rem;
    font-weight: 400;
    color: rgba(92, 92, 92, 1);
    line-height: 0.35rem;
    text-align: center;
  }

  .title24hleft {
    height: 0.35rem;
    font-size: 0.13rem;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    line-height: 0.35rem;
    text-align: center;
    background: #d4e8ff;
  }
  .title24hleft2 {
    height: 0.25rem;
    font-size: 0.13rem;
    font-family: NotoSansHans-Bold;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    padding-top: 2px;
    text-align: center;
    background: #d4e8ff;
    line-height: 0.25rem;
  }
  .title24h {
    font-size: 0.13rem;
    font-family: NotoSansHans-Bold;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    margin-top: 2px;

    text-align: center;
  }
  .title3word1 {
    font-size: 0.07rem;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    color: rgba(92, 92, 92, 1);
    line-height: 0.35rem;

    text-align: center;
  }
  .title24h1 {
    font-size: 0.13rem;
    font-family: NotoSansHans-Bold;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    margin-top: -5px;

    text-align: center;
  }
  .title24h2 {
    font-size: 0.13rem;
    font-family: NotoSansHans-Bold;
    font-weight: bold;
    color: rgba(57, 68, 70, 1);
    line-height: 0.3rem;
    margin-left: 0.1rem;
  }
  .table301 {
    text-align: center;
    font-size: 0.1rem;
    font-weight: 500;
    color: rgba(57, 68, 70, 1);
    line-height: 0.25rem;
    vertical-align: top;
  }
  .table311 {
    text-align: center;
    font-size: 0.1rem;
    font-family: NotoSansHans-Medium;
    font-weight: 500;
    color: rgba(57, 68, 70, 1);
    line-height: 0.25rem;
    border-right: 0.01rem solid #dcdcdc;
    border-bottom: 0.01rem solid #dcdcdc;
  }
  .table322 {
    width: 20%;
    border-right: 0.01rem solid #dcdcdc;
    border-bottom: 0.01rem solid #dcdcdc;
    text-align: center;
    font-size: 0.1rem;
    color: rgba(135, 135, 135, 1);
    padding-top: 0.075rem;
    padding-bottom: 0.075rem;
  }
  .table321 {
    width: 25%;
    border-right: 0.01rem solid #dcdcdc;
    border-bottom: 0.01rem solid #dcdcdc;
    text-align: center;
    font-size: 0.07rem;
    color: rgba(135, 135, 135, 1);
    padding-top: 0.075rem;
    padding-bottom: 0.075rem;
  }
}
.img {
  width: 100%;
}
</style>